// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/DribbbleSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var DribbbleSquareOutlined = function DribbbleSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleSquareOutlinedSvg
  }));
};

DribbbleSquareOutlined.displayName = 'DribbbleSquareOutlined';
export default React.forwardRef(DribbbleSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DribbbleSquareOutlined.js
// module id = 995
// module chunks = 0